export default {
    namespaced: true,
    state: {
        lang: "en",
    },
    mutations: {
        setLanguage: (state, payload) => {
            state.lang = payload
        },
    },
    actions: {
        setLanguage : (state, payload) => {
            state.commit("setLanguage", payload);
        },
    },
    getters: {
        selectLangData: (state) => state.lang,
    },
}